export const USER_UNKNOWN = 'user_unknown';
export const USER_READY = 'user_ready';

export const USER_UPDATE_PENDING = 'user_update_pending';
export const USER_UPDATE_FAILED = 'user_update_failed';
export const USER_UPDATE_SUCCESS = 'user_update_success';
